document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(accordionItem => {
        const bookingIndex = accordionItem.querySelector('.booking-items').id.split('-')[1];
        const bookingItems = accordionItem.querySelectorAll('.booking-item');
        const loadMoreBtn = accordionItem.querySelector('.load-more-btn');
        let visibleItems;

        function isSmallScreen() {
            return window.innerWidth < 768;
        }

        function updateItemCounts() {
            visibleItems = isSmallScreen() ? 3 : 6;
        }

        function updateVisibility() {
            bookingItems.forEach((item, index) => {
                if (index < visibleItems) {
                    item.classList.remove('d-none');
                } else {
                    item.classList.add('d-none');
                }
            });

            if (visibleItems >= bookingItems.length) {
                loadMoreBtn.textContent = 'Weniger anzeigen';
            } else {
                loadMoreBtn.textContent = 'Mehr Kurstermine anzeigen';
            }
        }

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', function() {
                if (visibleItems < bookingItems.length) {
                    visibleItems = bookingItems.length; // Show all items
                } else {
                    updateItemCounts(); // Reset to initial count
                }
                updateVisibility();
            });
        }

        // Initial setup
        updateItemCounts();
        updateVisibility();
        if (loadMoreBtn) {
            loadMoreBtn.style.display = bookingItems.length > visibleItems ? 'inline-block' : 'none';
        }

        // Update on window resize
        window.addEventListener('resize', function() {
            const wasExpanded = visibleItems === bookingItems.length;
            updateItemCounts();
            if (!wasExpanded) {
                updateVisibility();
            }
            if (loadMoreBtn) {
                loadMoreBtn.style.display = bookingItems.length > visibleItems ? 'inline-block' : 'none';
            }
        });
    });
});